import { payMCopyDateStatusInversed } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import { ModalSmallFilledOutside } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'


interface ModalConfirmMarkAsPaidPayMCopyDateProps extends ModalEditComponentProps { }

const ModalConfirmMarkAsPaidPayMCopyDate: React.FC<ModalConfirmMarkAsPaidPayMCopyDateProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/payment/paymentMethod/changeStatusPaymentMethodCopyDates',
        data: {
            selectedIds: [allRowData?.id],
            status: payMCopyDateStatusInversed['payed']
        }
    })
    return (<ModalSmallFilledOutside opened={true} setOpened={() => { setOpened(null) }} onClickOut={false} onAccept={handleFetchText} translations={{
        title: t('confirmPaidPayment', 'Confirmar como pagado este pago'),
        subtitle: t('surePaidPayment', '¿Seguro que quieres marcar como pagado este pago?'),
        buttonAccept: t('accept', 'Aceptar')
    }} />)
}


export default ModalConfirmMarkAsPaidPayMCopyDate